import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';

import { formatRelativeTime } from './format-relative-time';
import type { CommentAuthor } from './types';

const deriveDisplayName = (author: CommentAuthor, fallback: string): string => {
    const parts = [author.firstName, author.lastName].map((part) => part.trim()).filter((part) => part.length > 0);
    if (parts.length === 0) return fallback;
    return parts.join(' ');
};

type CommentMessageProps = {
    readonly author: CommentAuthor;
    readonly content: string;
    readonly createdAt: string;
};

export const CommentMessage: FunctionComponent<CommentMessageProps> = ({ author, content, createdAt }) => {
    const translate = useTranslate();

    return (
        <div className="min-w-0 flex-1">
            <div className="min-w-0">
                <div className="grid min-w-0 grid-cols-[minmax(0,auto)_max-content] items-center justify-start gap-xs">
                    <span className="min-w-0 truncate text-xs font-medium leading-[1rem] tracking-tight text-black-900">
                        {deriveDisplayName(
                            author,
                            translate('pages.job-architecture-v2.comments.thread.unknown-author'),
                        )}
                    </span>
                    <span className="text-xxs leading-[1rem] tabular-nums tracking-tight text-gray-600">
                        {formatRelativeTime(createdAt)}
                    </span>
                </div>
                <p className="m-0 mt-xxs break-words text-xs font-normal leading-[1.25rem] tracking-tight text-black-800">
                    {content}
                </p>
            </div>
        </div>
    );
};
